<template>
  <div class="price-intro-container">
    <div class="left-image">
      <img src="../assets/left.jpg" alt="左侧图片" />
    </div>
    <div class="right-image">
      <img src="../assets/right.png" alt="右侧图片" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PriceIntro",
};
</script>

<style scoped>
.price-intro-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
}

.left-image,
.right-image {
  width: 48%;
  max-width: 600px;
  border: 2px solid #ddd;
  border-radius: 20px;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
  margin: 0 auto;
}

.left-image img,
.right-image img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
